import React from "react";
import WisdomPlaceholderSquare from "../images/wisdom-placeholder-square.png";

export default class Image extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loaded: false
    }
  }

  onLoad = () => {
    this.setState({ loaded: true });
  }

  render() {
    const { src, placeholder = WisdomPlaceholderSquare, PlaceholderComponent, ...props } = this.props
    const { loaded } = this.state;
    const imageStyle = !loaded ? { display: "none" } : {};
    const component = PlaceholderComponent || <img src={placeholder} />
    return [
      !loaded && component,
      <img src={src} {...props} style={imageStyle} onLoad={this.onLoad} />
    ]
  }
}
